<template>
    <div class="worldcup--general-section">
        <a class="back" @click="ClickHideComponent" data-toggle="modal" href="javascript:void(0)">
            <img src="/assets/img/icon-back.svg" alt="back"/>
        </a>
        <b-tabs class="tab-modal line-tab">
            <b-tab title="lịch sử thưởng" active :disabled="!currentUser">
                <div class="worldcup--box-tab history-rule">
                    <History class="mobile" />
                </div>
            </b-tab>
            <b-tab title="ĐIỀU KIỆN THƯỞNG">
                <div class="worldcup--box-tab history-rule">
                    <Conditions class="mobile" />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import Conditions from '~/components/event/worldcup/tabs/conditions.vue';
// eslint-disable-next-line import/no-unresolved
import History from '~/components/event/worldcup/tabs/history.vue';

export default {
    components: {
        Conditions,
        History
    },
    methods: {
        ClickHideComponent() {
            this.$emit('hideComponent');
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    }
};
</script>
